// Deterministic SVG avatar for agents. Same name → same color +
// initials. Phase 5 swaps in AI-generated illustrated PNGs; until
// then this gets us recognizable cards without external deps.

const PALETTE = [
  ["#fef3c7", "#92400e"], // amber
  ["#dbeafe", "#1e40af"], // blue
  ["#dcfce7", "#166534"], // green
  ["#ffedd5", "#9a3412"], // orange
  ["#f3e8ff", "#6b21a8"], // purple
  ["#ccfbf1", "#115e59"], // teal
  ["#ffe4e6", "#9f1239"], // rose
  ["#e0f2fe", "#075985"], // sky
];

function hash(str: string): number {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function AgentAvatar({
  id,
  displayName,
  emoji,
  size = 48,
  url,
}: {
  id: string;
  displayName: string;
  emoji?: string | null;
  /** When set (Phase 5 illustrated avatars), used directly; falls back to SVG. */
  url?: string | null;
  size?: number;
}) {
  if (url) {
    return (
      <img
        src={url}
        alt={displayName}
        width={size}
        height={size}
        className="rounded-full object-cover"
      />
    );
  }
  const [bg, fg] = PALETTE[hash(id) % PALETTE.length]!;
  const fontSize = Math.round(size * (emoji ? 0.55 : 0.42));
  // First letter of each whitespace-separated word, max 2.
  const initials = displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join("");
  return (
    <div
      className="rounded-full flex items-center justify-center font-display font-bold flex-shrink-0"
      style={{ width: size, height: size, backgroundColor: bg, color: fg, fontSize }}
      title={displayName}
    >
      {emoji || initials}
    </div>
  );
}
